import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=0b9de3fa"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"
import style0 from "./Counter.vue?vue&type=style&index=0&id=0b9de3fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports